/**
 * @desc 平台站点-查询站点详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformShopResponseDto>;
export function request(shopNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformShop/details/${shopNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
